export const SortField = {
  Id: 'id',
  Name: 'users.name'
};

export const SortDirection = {
  Asc: 'asc',
  Desc: 'desc'
};
